import {
  BarChart3,
  Flag,
  LayoutDashboard,
  MapPin,
  Megaphone,
  ScrollText,
  TerminalSquare,
  Users,
} from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

/**
 * Sidebar del panel /admin: nav vertical con las secciones. Vive dentro
 * de `MainLayout` (Sprint Admin C.1.x) — ya no es top-level, así que sin
 * `sticky`/`h-screen`. El logout sigue accesible desde el `UserMenu` del
 * SiteHeader, no se duplica aquí.
 */
export function AdminSidebar() {
  const { t } = useTranslation()

  return (
    <aside className="brutal-lg hidden h-fit w-56 shrink-0 rounded-2xl bg-background-alt p-5 md:block">
      <nav className="flex flex-col gap-2">
        <SidebarLink to="/admin" end icon={<LayoutDashboard size={16} />}>
          {t('admin.nav.dashboard')}
        </SidebarLink>
        <SidebarLink to="/admin/reports" icon={<Flag size={16} />}>
          {t('admin.nav.reports')}
        </SidebarLink>
        <SidebarLink to="/admin/users" icon={<Users size={16} />}>
          {t('admin.nav.users')}
        </SidebarLink>
        <SidebarLink to="/admin/stats" icon={<BarChart3 size={16} />}>
          {t('admin.nav.stats')}
        </SidebarLink>
        <SidebarLink to="/admin/hero-campaigns" icon={<Megaphone size={16} />}>
          {t('admin.nav.heroCampaigns')}
        </SidebarLink>
        <SidebarLink to="/admin/locales" icon={<MapPin size={16} />}>
          {t('admin.nav.venues')}
        </SidebarLink>
        <SidebarLink to="/admin/audit" icon={<ScrollText size={16} />}>
          {t('admin.nav.audit')}
        </SidebarLink>
        <SidebarLink to="/debug/crons" icon={<TerminalSquare size={16} />}>
          {t('admin.nav.crons')}
        </SidebarLink>
      </nav>
    </aside>
  )
}

interface SidebarLinkProps {
  to: string
  icon: ReactNode
  children: ReactNode
  end?: boolean
}

function SidebarLink({ to, icon, children, end }: SidebarLinkProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `brutal-sm brutal-press inline-flex items-center gap-2 rounded-lg px-3 py-2 font-display text-sm font-bold uppercase tracking-wider ${
          isActive ? 'bg-yellow' : 'bg-background'
        }`
      }
    >
      {icon} {children}
    </NavLink>
  )
}
